import { Box, Typography } from "@mui/material";
import React from "react";

const DisplayCard = ({ data }) => {
  const FieldName = [
    {
      name: "Vehicle",
      value: data.carId.name + " " + data.carId.model,
    },
    {
      name: "Buyer Name",
      value: data.Buyer.name,
    },

    {
      name: "Contact Number",
      value: data.Buyer.contact[0],
    },
    {
      name: "Vehicle Number",
      value: data.carId.vehicleNumber,
    },
  ];
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "2rem",
          borderRadius: "0.5rem",
          border: "1px solid",
          borderColor: "grey.200",
          mt: "1rem",
          width: "80%",
        }}
        className="bg-black/10"
      >
        <Typography variant="h4" component="span" className="font-extrabold">
          Details
        </Typography>

        {FieldName.map((item) => (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              borderRadius: "0.5rem",
              width: "100%",
              gap: "1rem",
              padding: "0.5rem",
            }}
            key={item.value}
          >
            <Typography variant="h6" component="span">
              {item.name}
            </Typography>
            <Typography variant="h6" component="span">
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default DisplayCard;
